import React from 'react';
import { Card, Icon } from 'antd';
import "./NewRequirement.less";

interface INewSingleItemRequirement {
    newSingleItemClick(): void;
    className?:string;
}

export const NewSingleItemRequirement = (props: INewSingleItemRequirement) =>
    <div className={`new-requirement ${props.className?props.className:""}`}>
        <Card className="new-template-card" bordered={true} style={{ width: 150 }}>
            <div className="new-single-requirement"
                onClick={props.newSingleItemClick}>
                <Icon type="file-add" />
            </div>
        </Card>
    </div>